export default class Category {
  categoryId;
  categoryName;
  categoryDescription;
  motifIndexes;
  constructor(jsonData) {
    Object.assign(this, jsonData);
  }
}
